<app-alert-box-component 
  (OnButtonClick)="onAlertButtonClick($event)"
  (OnAlertClose)="closeAlert($event)" 
  (OnAlertVisibility)="alertVisibility($event)"
  [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText" 
  [alertBodyText]="alertBodyText" 
  [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText"
  [data]="alertBoxData"
  [bAlert]="bAlert"></app-alert-box-component>
  
<c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
    <c-container fluid>
    <form cForm class="row" [formGroup]="cifSearchForm" (ngSubmit)="generateReport()">
        <c-row [gutter]="{gy: 1}">
            <c-col lg="6">
                <c-date-range-picker [startDate]="startDate" [endDate]="endDate" (startDateChange)="onStartDateChane($event)"  (endDateChange)="onEndDateChane($event)"></c-date-range-picker>
            </c-col>
            <c-col md="auto">
                <button cButton type="submit">
                    Generate Report
                </button>
            </c-col>
            <c-col md="auto">
                <button *ngIf="bShowDownloadButton" cButton (click)="downloadReport()">
                    Download Report
                </button>
            </c-col>
        </c-row>
    </form>
</c-container>
</c-navbar>

<c-smart-table id="auditReportTable"
[columnSorter]="true"
[columns]="columns"
[columnFilter]="true"
[itemsPerPageSelect]="true"
[itemsPerPage]="10" 
[items]="reportData"
[tableBodyProps]="{ align: 'middle' }"
[tableProps]="{ hover: true, striped: true, responsive: true }"
[pagination]="true"
clickableRows
header
pagination>
<ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
    <td>
    <ng-container [ngSwitch]="columnName">
        <ng-container *ngSwitchCase="'requestedOn'">
            {{(getDateDisplayString(item.requestedOn))}}
        </ng-container>
        <ng-container *ngSwitchCase="'decisionOn'">
            {{(getDateDisplayString(item.decisionOn))}}
        </ng-container>
        <ng-container *ngSwitchCase="'oldDateOfBirth'">
            {{(getDateDisplayString(item.oldDateOfBirth))}}
        </ng-container>
        <ng-container *ngSwitchCase="'oldExpiresOn'">
            {{(getDateDisplayString(item.oldExpiresOn))}}
        </ng-container>
        <ng-container *ngSwitchCase="'dateOfBirth'">
            {{(getDateDisplayString(item.dateOfBirth))}}
        </ng-container>
        <ng-container *ngSwitchCase="'expiresOn'">
            {{(getDateDisplayString(item.expiresOn))}}
        </ng-container>
        <ng-container *ngSwitchDefault>
            {{tdContent}}
        </ng-container>
    </ng-container>
    </td>
</ng-template>
</c-smart-table>